(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/init.js');
"use strict";


const {
  BrowserRouter,
  Switch,
  Redirect,
  Route
} = ReactRouterDOM;
const {
  baseUrl
} = svs.core.data;
const {
  connect,
  Provider
} = ReactRedux;
const {
  InjectSelfserviceCallback
} = svs.challenge;
const {
  CouponQueryParams
} = svs.components.sport.tipsenShared;
svs.challenge.init = () => {
  const Router = _ref => {
    let {
      firstDraw
    } = _ref;
    return React.createElement(BrowserRouter, {
      basename: baseUrl
    }, React.createElement(Switch, null, firstDraw && React.createElement(Redirect, {
      exact: true,
      from: "/spela",
      to: "/spela/".concat(firstDraw.drawNumber)
    }), React.createElement(Route, {
      component: svs.challenge.StartPage,
      exact: true,
      path: "/"
    }), React.createElement(Route, {
      component: svs.challenge.PlayContainer,
      path: "/spela/:drawNumber([0-9]+)([/]*):eventNumber([0-9]+)?(-[a-z0-9-]*)?"
    })), React.createElement(Route, {
      component: InjectSelfserviceCallback,
      path: "/spela/:drawNumber([0-9]+)"
    }));
  };
  const mapStateToProps = state => {
    if (state.draws.length === 0) {
      return {};
    }
    return {
      firstDraw: state.draws[0]
    };
  };
  svs.challenge.Router = connect(mapStateToProps)(Router);
  const render = () => {
    ReactDOM.render( React.createElement(Provider, {
      store: svs.challenge.store
    }, React.createElement(svs.challenge.Router, null)), document.getElementById('reactContainer'));
  };
  const searchParams = new URLSearchParams(location.search);
  const querySigns = searchParams.get(CouponQueryParams.PARAM_SIGNS);
  if (querySigns) {
    const splitPathName = location.pathname.split('/');
    const drawNumber = parseInt(splitPathName[splitPathName.length - 1], 10);
    svs.challenge.store.dispatch(svs.challenge.actions.loadFromUrlParameters(querySigns, drawNumber));
    render();
  } else {
    svs.components.Storage.browser.get(svs.challenge.constants.LOCAL_STORAGE_NAME, svs.challenge.constants.LOCAL_STORAGE_DOMAIN, data => {
      if (data) {
        svs.challenge.store.dispatch(svs.challenge.actions.loadFromLocalStorage(data));
      }
      render();
    });
  }
};
svs.challenge.init();

 })(window);